// Core
import React from 'react';
import FilterBar from '../../components/FilterBar';
import ProgressBar from 'react-bootstrap/ProgressBar';
import './index.scss';
import { useTags } from './useTags';

// Components
import { GeckoCardTable, GECKO_CONSTS, GeckoLabel } from 'ui';
import StatsLoader from 'routes/stats/components/StatsLoader';

// Other

const cols = [
  {
    key: 'name',
    name: 'Tag Name',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT,
    render: (name) => {
      if (name.startsWith('✨')) {
        return (
          <>
            <i className="far fa-sparkles gradient-icon"></i>
            {name.slice(1)}
          </>
        );
      } else {
        return name;
      }
    },
  },
  {
    key: 'count',
    name: 'Number of times used',
    class: 'tag-count',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT,
    render: (value, _key) => {
      const percentage = _key.percentage;
      return (
        <>
          <div className="tag-progress">
            <div className="tag-name">{value}</div>
            <ProgressBar now={percentage} />
          </div>
        </>
      );
    },
  },
  {
    key: 'positive',
    name: 'Positive',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM,
    class: 'positive',
    width: '10%',
    render: (name) => {
      return <>{name || '0'}</>;
    },
  },
  {
    key: 'neutral',
    name: 'Neutral',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM,
    class: 'neutral',
    width: '10%',
    render: (name) => {
      return <>{name || '0'}</>;
    },
  },
  {
    key: 'negative',
    name: 'Negative',
    class: 'negative',
    width: '10%',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT,
    render: (name) => {
      return <>{name || '0'}</>;
    },
  },
  {
    key: 'general',
    name: 'General Sentiment',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM,
    width: '10%',
    class: 'general',
    render: (value) => {
      const getType = (value) => {
        switch (value) {
          case 'Negative':
            return 'danger';
          case 'Positive':
            return 'success';
          default:
            return 'default';
        }
      };
      return (
        <GeckoLabel
          name={value}
          type={getType(value?.replace(/[0-9%+\s]/g, ''))}
        />
      );
    },
  },
];

const Tags = () => {
  const {
    topTagsWithAiEmoji,
    filters,
    handleFiltersChange,
    pagination,
    extraFilterProps,
    fetchingTopTagsStats,
  } = useTags();

  const iconText =
    'The frequency of tags used in conversations within the filtered period.';

  return (
    <>
      <FilterBar
        filterByDates
        filterByAgents
        filterByBots
        filterByTags
        filterByChannels
        startDate={filters.startDate}
        endDate={filters.endDate}
        filter={handleFiltersChange}
        {...extraFilterProps}
      />
      <StatsLoader isLoading={fetchingTopTagsStats}>
        <GeckoCardTable
          headerProps={{
            iconText,
          }}
          headerIcon="fa fa-question-circle"
          cols={cols}
          rows={topTagsWithAiEmoji}
          name="Tag Summary"
          pagination={pagination}
        />
      </StatsLoader>
    </>
  );
};

export default Tags;
